// src/pages/LocationsPage.jsx
import MastersCrudPage from "../components/MastersCrudPage";
import {
  listLocations,
  createLocation,
  updateLocation,
  deleteLocation,
} from "../api/mastersApi";

export default function LocationsPage() {
  return (
    <MastersCrudPage
      title="Locations"
      fetchList={listLocations}
      createItem={createLocation}
      updateItem={updateLocation}
      deleteItem={deleteLocation}
      columns={[
        { key: "id", label: "ID" },
        { key: "name", label: "Nombre" },
        { key: "address", label: "Dirección" },
        { key: "timezone", label: "Zona horaria" },
        { key: "is_active", label: "Activo" },
      ]}
      initialForm={() => ({ name: "", address: "", timezone: "America/Guayaquil", is_active: 1 })}
      renderForm={({ form, setForm }) => (
        <>
          <div>
            <label className="block text-xs text-gray-400">Nombre</label>
            <input name="name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" required />
          </div>
          <div>
            <label className="block text-xs text-gray-400">Dirección</label>
            <input name="address" value={form.address} onChange={e => setForm({...form, address: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-xs text-gray-400">Timezone</label>
              <input name="timezone" value={form.timezone} onChange={e => setForm({...form, timezone: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
            </div>
            <div>
              <label className="block text-xs text-gray-400">Activo</label>
              <select value={form.is_active} onChange={e => setForm({...form, is_active: Number(e.target.value)})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
                <option value={1}>Sí</option>
                <option value={0}>No</option>
              </select>
            </div>
          </div>
        </>
      )}
    />
  );
}
